module.exports = __webpack_public_path__ + "img/role-mangement.0c29e3d3.svg";